import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { isEmpty } from '@ember/utils';

export default class AssessmentsRoute extends Route {
  model() {
    return hash({
      group: this.modelFor('group'),
      learners: this.modelFor('group.insights').learners,
      assessments: this.modelFor('group.insights')
        .assessments.slice()
        .sort((a, b) => (a.label || '').localeCompare(b.label || '')),
    });
  }

  setupController(controller, model) {
    super.setupController(...arguments);

    if (!isEmpty(model.assessments)) {
      controller.set('assessmentId', model.assessments[0].id);
    }
  }
}
